import {
	Flex,
	Text,
	INNER_MAX_WIDTH,
	READABLE_LINE_MAX_WIDTH,
	scale,
	breakpoint,
	Tabs,
} from "@capioweb/ui-components/src"
import styled from "styled-components"
import { ChildrenProps, SharedFormProps } from "../../../@types/CapioWeb/core"
import { StringProperty } from "../../../@types/EpiFoundationSpa/Property"
import React from "react"
import { ManageAccount } from "./ManageAccount/ManageAccount"
import { ManageInterests } from "./ManageInterests/ManageInterests"

interface MyPagesManageAccountInformationBlockProps {
	accountHeading: StringProperty
	accountIngress?: StringProperty
	interestsHeading: StringProperty
	interestsIngress?: StringProperty
	accountForm: SharedFormProps
	interestsForm?: SharedFormProps
	enableInterests: boolean
	children?: React.ReactNode
}

const FormContainer = styled(Flex)`
	flex-direction: column;
	padding: ${scale.px(5)} ${scale.px(3)};
	max-width: ${scale.px(INNER_MAX_WIDTH)};
	margin: 0 auto;

	${breakpoint("m")`
		border-radius: ${scale.px(3)};
		padding: ${scale.px(5)} ${scale.px(8)};
		`}
`

const LayoutContainer: React.FC<ChildrenProps> = (props) => {
	return (
		<Flex w={1} flexDirection="column" px={3} pt={{ _: 2, m: 0 }}>
			<Flex flexDirection="column" w={1} maxw={INNER_MAX_WIDTH} m="0 auto">
				{props.children}
			</Flex>
		</Flex>
	)
}

export const MyPagesManageAccountInformationBlock: React.FC<MyPagesManageAccountInformationBlockProps> =
	(props) => {
		return (
			<Flex w={1} pb={4}>
				<Flex alignItems="center" flexDirection="column" w={1}>
					{/* Tabs for Manage Account and Manage Interests forms */}
					<Flex w={1} flexDirection="column" as="section" pb={4}>
						{props.interestsForm ? (
							<Tabs defaultActiveTabId="account">
								<Tabs.Tab id="account" title={props.accountHeading.value}>
									<LayoutContainer>
										<Flex
											flexDirection="column"
											maxw={READABLE_LINE_MAX_WIDTH}
											mb={5}
										>
											<Text variant="headline-2">
												{props.accountHeading.value}
											</Text>
											{props.accountIngress?.value && (
												<Text variant="paragraph-16" mb={0}>
													{props.accountIngress?.value}
												</Text>
											)}
										</Flex>
									</LayoutContainer>
									<FormContainer backgroundColor="yellow11">
										<ManageAccount {...props.accountForm} />
									</FormContainer>
								</Tabs.Tab>
								<Tabs.Tab id="interest" title={props.interestsHeading.value}>
									<LayoutContainer>
										<Flex
											flexDirection="column"
											maxw={READABLE_LINE_MAX_WIDTH}
											mb={5}
										>
											<Text variant="headline-2">
												{props.interestsHeading.value}
											</Text>
											{props.interestsIngress?.value && (
												<Text variant="paragraph-16" mb={0}>
													{props.interestsIngress?.value}
												</Text>
											)}
										</Flex>
									</LayoutContainer>
									<FormContainer backgroundColor="blue11">
										<ManageInterests {...props.interestsForm} />
									</FormContainer>
								</Tabs.Tab>
							</Tabs>
						) : (
							<Tabs defaultActiveTabId="account">
								<Tabs.Tab id="account" title={props.accountHeading.value}>
									<LayoutContainer>
										<Flex
											flexDirection="column"
											maxw={READABLE_LINE_MAX_WIDTH}
											mb={5}
										>
											<Text variant="headline-2">
												{props.accountHeading.value}
											</Text>
											{props.accountIngress?.value && (
												<Text variant="paragraph-16" mb={0}>
													{props.accountIngress?.value}
												</Text>
											)}
										</Flex>
									</LayoutContainer>
									<FormContainer backgroundColor="yellow11">
										<ManageAccount {...props.accountForm} />
									</FormContainer>
								</Tabs.Tab>
							</Tabs>
						)}
					</Flex>
				</Flex>
			</Flex>
		)
	}
